import type { HTMLAttributes, ReactNode } from "react";
import classNames from "classnames/dedupe";

type QuoteCardBadgesProps = {
  children: ReactNode;
} & HTMLAttributes<HTMLDivElement>;

export function QuoteCardBadges({ children, className }: QuoteCardBadgesProps) {
  const quoteCardBadgesClasses = classNames(
    "mobius-quote-card__badges",
    className,
  );

  return (
    <div className={quoteCardBadgesClasses} data-testid="quote-card-badges">
      {children}
    </div>
  );
}
